/**
 * 7セグメント表示の設定を管理するフック
 */
export interface SevenSegConfig {
    segOnColor: string;
    segOffColor: string;
    colonOnColor: string;
    colonOffColor: string;
    // サイズ設定
    getTimeDisplaySize: (baseFontSize: number) => {
        width: number;
        height: number;
        thickness: number;
        colonWidth: number;
    };
    getDateDisplaySize: (baseFontSize: number) => {
        width: number;
        height: number;
        thickness: number;
    };
}

/**
 * 7セグメント表示の設定を取得する
 * @param isDark ダークモードかどうか
 * @returns 7セグメント表示の設定
 */
export function useSevenSegConfig(isDark: boolean): SevenSegConfig {
    return {
        segOnColor: isDark ? '#ffffff' : '#111111',
        segOffColor: isDark ? '#111111' : '#f5f5f5',
        colonOnColor: isDark ? '#ffffff' : '#111111',
        colonOffColor: isDark ? '#111111' : '#f5f5f5',
        // 時間表示のサイズ設定（1回り大きく）
        getTimeDisplaySize: (baseFontSize: number) => ({
            width: Math.max(30, baseFontSize * 2),
            height: Math.max(45, baseFontSize * 3.8),
            thickness: Math.max(4, baseFontSize * 0.4),
            colonWidth: Math.max(8, baseFontSize * 0.5),
        }),
        // 日付表示のサイズ設定（時間表示より小さく）
        getDateDisplaySize: (baseFontSize: number) => ({
            width: Math.max(18, baseFontSize * 1.2),
            height: Math.max(27, baseFontSize * 2.2),
            thickness: Math.max(3, baseFontSize * 0.25),
        }),
    };
}
